export default __webpack_public_path__ + "static/lower3_3-7d89f331aca2d8a3400ae65b9f77a50e.jpg";